import CookieConfig from "../config/Cookie.config";
import Usuario from "../interfaces/Usuario.interface"
import Cookies from 'universal-cookie';

const cookies: Cookies = new Cookies(CookieConfig.param, CookieConfig.object);

const getEstructura = (): Usuario => {
    const usuario: Usuario = {
        IdUsuario: 0,
        nombreCompleto: "",
        username: "",
        password: "",
        estatus: { IdEstatus: 0, valor: "" },
        correoElectronico: "",
        passwordCorreoElectronico: "",
        telefono: "",
        fotoPerfil: "",
        observaciones: "",
        fechaCreado: "",
        horaCreado: ""
    }
    return usuario;
}

const cast = (data: any): Usuario => {
    const usuario: Usuario = {
        IdUsuario: data.IdUsuario ?? 0,
        nombreCompleto: data.nombreCompleto ?? "",
        username: data.username ?? "",
        password: data.password ?? "",
        estatus: {
            IdEstatus: data.IdEstatus ?? 0,
            valor: data.estatus ?? "###"
        },
        correoElectronico: data.correoElectronico ?? "",
        passwordCorreoElectronico: data.passwordCorreoElectronico ?? "",
        telefono: data.telefono ?? "",
        fotoPerfil: data.fotoPerfil ?? "",
        observaciones: data.observaciones ?? "",
        fechaCreado: data.fechaCreado ?? "",
        horaCreado: data.horaCreado ?? ""
    };
    return usuario;
};

const cookie = async (): Promise<Usuario> => {
    const usuario: Usuario | undefined = cookies.get("usuario");
    if (usuario === undefined) {
        return getEstructura();
    }
    return usuario;
};

const cookieRemove = async (): Promise<void> => {
    cookies.remove("usuario");
};

const UsuarioModel = {
    cast,
    getEstructura,
    cookie,
    cookieRemove,
};

export default UsuarioModel;